<script>
export default {
  name: "NetworkStatus",
  data() {
    return {
      offline: false,
    };
  },
  mounted() {
    if (!window.navigator.onLine) {
      this.offline = true;
    }
    window.addEventListener("online", () => {
      this.offline = false;
    });
    window.addEventListener("offline", () => {
      this.offline = true;
    });
  },
};
</script>

<template>
  <div class="network-status" v-if="offline">
    <?xml version="1.0" encoding="utf-8"?>
    <!-- Generator: Adobe Illustrator 27.9.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px" viewBox="0 0 409.6 409.6" overflow="visible" xml:space="preserve" fill="#fff" style="width: 10vw; height: 10vh">
<g>
	<g>
		<path d="M0.8,234.7c2.5-4.9,2.6-10.4,4.4-15.5c6.1-16.8,16.1-30.5,31-40.3c3.2-2.1,4.1-4.2,3.7-8
			c-3.6-36.2,15.9-67.7,50-80.1c21.1-7.7,41.9-5.7,61.6,5.1c3.6,2,5.2,1.8,7.8-1.6C179,67.6,205.9,53,238.9,52.5
			c42.7-0.7,74.8,18.7,94.9,56.6c12.2,22.9,14.1,47.4,7.7,72.4c-2,8.1-6.8,11.1-15,9.7c-43.8-7.4-83.7,24.4-86.4,68.8
			c-2.6,43.5,33.2,79.9,76.6,77.9c39.7-1.8,70.4-33.1,71.1-72.9c0.3-16.3-4.6-31.2-14.2-44.4c-1.8-2.5-4-4.7-4.8-7.7
			c-1.2-5.1,1.1-10.1,5.7-12.4c4.5-2.2,10-1.1,13.3,3.1c9.4,11.6,16.1,24.7,19.2,39.4c9,42.7-9,83-46.8,104.9
			c-33.4,19.3-79.6,14.7-108.4-11c-3.3-2.9-6.6-5.8-9.3-9.3c-1.7-2.1-3.6-2.7-6.2-2.7c-51.2,0.1-102.5,0.1-153.7,0
			c-27.8,0-50.2-11.1-66.8-33.5c-7.1-9.5-11.5-20.3-13.7-32c-0.3-1.6,0.1-3.5-1.4-4.8C0.8,248,0.8,241.4,0.8,234.7z M150.9,303.3
			c23.8,0,47.6,0,71.4,0c2.2,0,4.4,0.5,2.9-3.2c-6.7-16.5-8.8-33.5-5.8-51.2c4.8-28.2,19.3-50,43.2-65.5
			c16.7-10.9,35.3-15.7,55.3-14.9c3.3,0.1,4.5-0.5,4.9-4.2c0.8-7.8,0.4-15.3-0.8-23c-5.5-35.2-35.8-63.7-71.4-67.1
			c-33.4-3.2-64.5,13.4-80.5,43.1c-4.9,9-11.6,10.4-19.4,3.9c-11.8-9.9-25.2-14.4-40.6-12.8c-21.5,2.3-36.9,13.6-44.9,33.4
			c-8.2,20.2-4.8,39.5,9.7,56.1c10.2,11.7,23.3,17.7,38.9,18.4c6.5,0.3,11.3,5,11.3,11c0,5.9-5.1,10.5-11.7,10.6
			c-11.3,0.1-22.1-2.3-32.4-7.1c-13.7-6.4-24.6-16.1-32.4-29.1c-2-3.3-3.2-3.2-5.8-0.7c-17.3,16.2-23.9,35.9-17.9,58.9
			c6.8,26.4,29.8,43.3,57.6,43.4C105.1,303.4,128,303.3,150.9,303.3z"/>
    <path fill="#F3B1AF" d="M290.1,298.2c-3.9-0.1-7.3-2.1-9.3-6.2c-2-4.3-1.4-8.4,1.8-11.8c4.4-4.7,8.9-9.2,13.5-13.6
			c2.1-2,1.9-3.1-0.1-5c-4.3-4-8.4-8.2-12.4-12.4c-5-5.1-5.2-11.4-0.7-15.9c4.5-4.5,10.9-4.3,16,0.6c4.2,4.1,8.4,8.1,12.4,12.5
			c2.1,2.3,3.3,2,5.3-0.1c3.9-4.2,8-8.2,12.1-12.2c5.3-5.1,11.7-5.4,16.2-0.7c4.5,4.6,4.2,10.8-0.8,16c-4.2,4.3-8.4,8.6-12.7,12.7
			c-1.8,1.7-1.7,2.7,0,4.4c4.3,4.1,8.5,8.4,12.7,12.7c5,5.1,5.2,11.4,0.8,16c-4.4,4.5-10.9,4.3-16-0.6c-4.2-4.1-8.4-8.1-12.4-12.4
			c-2.1-2.3-3.3-2-5.3,0.1c-4,4.3-8.2,8.3-12.4,12.5C296.6,296.7,293.9,298.1,290.1,298.2z"/>
    <path d="M150.9,303.3c-22.9,0-45.8,0-68.7,0c-27.8-0.1-50.8-16.9-57.6-43.4c-5.9-23,0.6-42.7,17.9-58.9
			c2.6-2.5,3.9-2.5,5.8,0.7c7.8,13,18.7,22.7,32.4,29.1c10.3,4.8,21.1,7.2,32.4,7.1c6.6-0.1,11.7-4.6,11.7-10.6
			c0-6-4.8-10.8-11.3-11c-15.5-0.7-28.7-6.7-38.9-18.4c-14.4-16.6-17.8-35.9-9.7-56.1c8-19.8,23.4-31.1,44.9-33.4
			c15.3-1.6,28.8,2.9,40.6,12.8c7.8,6.6,14.6,5.2,19.4-3.9c16-29.7,47-46.4,80.5-43.1c35.6,3.4,65.9,31.9,71.4,67.1
			c1.2,7.7,1.7,15.2,0.8,23c-0.4,3.6-1.6,4.3-4.9,4.2c-20-0.9-38.5,4-55.3,14.9c-23.9,15.5-38.4,37.3-43.2,65.5
			c-3,17.6-0.9,34.7,5.8,51.2c1.5,3.8-0.7,3.2-2.9,3.2C198.5,303.3,174.7,303.3,150.9,303.3z"/>
	</g>
</g>
</svg>

    <h1>
      You are currently offline.<br />
      Please connect to the Internet.
    </h1>
  </div>
</template>

<style scoped lang="scss">
.network-status {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  background: #14121f;
  z-index: 1000;

  .icon-disconnect {
    margin-top: auto;
    margin-bottom: vw(40);
  }
  h1 {
    color: #ffffff;
    text-align: center;
    font-size: 3vw;
    padding-bottom: 15vh;
  }
}
</style>
